import { render, staticRenderFns } from "./StrapiFichiersComponent.vue?vue&type=template&id=40b77d28"
import script from "./StrapiFichiersComponent.vue?vue&type=script&lang=js"
export * from "./StrapiFichiersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports